import { ACTIONS_UPDATED } from 'actiontypes/actions';

export default function actionsUpdated({ actions }) {
  return {
    type: ACTIONS_UPDATED,
    payload: { actions },
  };
}